import {Link, useNavigate} from "react-router-dom";
import {useRef, useState, useEffect} from "react";

/**
 * 메인 > 주체
 */
const SchoolSearch = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    // 모바일 툴팁 관련
    const [isTooltipVisible, setTooltipVisible] = useState(false);
    const toolTipRef = useRef(null);

    const [activeDescription, setActiveDescription] = useState([]);

    useEffect(() => {
        // 모바일 툴팁 외부 영역 클릭 시 툴팁 닫기
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const handleClickOutside = (e) => {
        if (toolTipRef.current && !toolTipRef.current.contains(e.target)) {
            setTooltipVisible(false);
        }
    };

    // 검색어 지정
    const handleTerm = (e) => {
        setSearchTerm(e.target.value);
    };

    // 검색
    const handleSearch = () => {
        if (searchTerm.length > 0) {
            navigate(`/school_search/${searchTerm}`);
        }
    };

    const onKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    // 설명 토글 핸들러
    const toggleDescription = (id) => {
        setActiveDescription((prev) => {
            if (prev.includes(id)) {
                // 이미 활성화된 ID라면 배열에서 제거
                return prev.filter((item) => item !== id);
            } else {
                // 활성화되지 않은 ID라면 배열에 추가
                return [...prev, id];
            }
        });
    };

    return (
        <main id="contents">
            <div className="sub-content">
                <div className="school-wrap">
                    <div className="cont-top">
                        <div className="w-set">
                            <div className="title-wrap">
                                <h2 className="title batang">공간</h2>
                                <p className="text">조선제학교일람을 통해 <br/>일제강점기 조선총독부가 조선의 교육 상황을 기록한 자료를 확인 할 수 있습니다.</p>
                            </div>
                        </div>
                    </div>
                    <div className="cont-btm">
                        <div className="w-set">
                            <div className="about-wrap">
                                <div className="video-wrap">
                                    <div className="video-box type-wide">
                                        <img src="/images/search/school_search_img.png" alt="배화여자고등보통학교(1935) - 교육박물관 소장" />
                                    </div>
                                    <p className="caption">배화여자고등보통학교(1935) - 교육박물관 소장</p>
                                </div>
                                <div className="school-search">
                                    <div className="text-wrap">
                                        <div className="sub-tit-wrap">
                                            <p className="sub-tit">조선제학교일람을 통해서 본 근대학교 변천</p>
                                            <div className="tooltip-wrap" ref={toolTipRef}>
                                                <button type="button" className="i-tool"
                                                    onClick={() => setTooltipVisible(!isTooltipVisible)}
                                                ></button>
                                                <div className={`tool-box ${isTooltipVisible ? 'on' : ''}`}>
                                                    <p className="tool-tit">제학교일람 수록 교육기관</p>
                                                    소학교, 국민학교, 보통학교, 공립 보통학교 부설 간이학교, 공립 소학교 부설 간이학교, 공립 국민학교 부설 간이학교, 도지사인정학교, 안동현 공립 보통 및 간도 훈춘 내 각학교, 중학교, 고등보통학교, 고등여학교, 여자고등보통학교, 사범학교, 실업학교(농업, 농잠, 농림학교), 상업학교, 상공학교, 공업학교, 수산학교, 공립 직업학교, 실업보습학교(농업, 농잠, 농림, 상업, 공업, 기업, 수산, 실업, 실과 여학교, 공립 여자실수학교, 기타 실업), 실업전수학교, 간이실업전수학교, 간이실업학교(농업, 수산, 상업, 공업), 전문학교, 관립대학 예과, 관립대학, 각종학교, 서당, 유치원, 도서관
                                                </div>
                                            </div>
                                        </div>
                                        <p><strong>『조선제학교일람』이란 무엇인가요?</strong></p>
                                        <p>
                                            『조선제학교일람』은 일제강점기 조선총독부가 조선의 교육 상황을 기록한 자료로, 초등부터 고등교육, 실업교육, 사범학교, 서당, 유치원,
                                            도서관 등 다양한 교육 기관의 정보를 담고 있습니다. 각 학교의 이름, 위치, 설립 연도, 학생 수, 교직원 수, 학급 수, 운영비 등
                                            세부 사항이 포함되어 있어 학교의 설립과 폐교, 명칭 및 종류의 변화를 확인할 수 있습니다. 또한 지역별, 성별, 민족별로 정리되어 남녀
                                            및 조선인과 일본인의 교육 상황 차이를 잘 보여줍니다.
                                        </p>
                                        <p>
                                            『일람』은 일제강점기 교육 기관의 전반적인 모습을 이해하는 데 중요한 역사적 자료입니다.
                                        </p>
                                    </div>
                                    <div className="search-wrap">
                                        <form action="">
                                            <div className="search-box">
                                                <div className="search-area">
                                                    <div className="input-wrap">
                                                        <label htmlFor="search">
                                                            <input type="text" name="search" placeholder="학교명 검색"
                                                                   onChange={handleTerm} onKeyDown={onKeyPress}/>
                                                        </label>
                                                        <button type="button" className="btn-search" onClick={handleSearch}>검색</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="btn-wrap type-center">
                                    <Link to="/archive/colonial_school" className="btn"><i className="i-book"></i>조선제학교일람
                                        목록보기</Link>
                                </div>
                            </div>
                            <div className="description-wrap">
                                <dl className="description">
                                    <dt>
                                        <Link
                                            to="#"
                                            className={activeDescription.includes(0) ? "des-tit on" : "des-tit"}
                                            onClick={() => toggleDescription(0)}
                                        >
                                            <p>일람에서 식민지 교육정책 변화과정을 볼 수 있습니다.</p>
                                            <i className="i-toggle"></i>
                                        </Link>
                                    </dt>
                                    <dd style={{
                                        height: activeDescription.includes(0) ? "auto" : "0",
                                        overflow: "hidden",
                                        transition: "height 0.3s ease",
                                    }}>
                                        <div className="des-view">
                                            <div className="text-wrap">
                                                <p>
                                                    『조선제학교일람』은 일제강점기 조선총독부가 만든 교육 관련 자료로, 당시 교육 정책의 변화를 잘 보여줍니다. 이 자료는
                                                    조선인의 학교와 일본인의 학교가 어떻게 운영되었는지 기록되어 있어, 그 역사적 가치가 매우 큽니다. 조선총독부는 제1차
                                                    교육령을 통해 보통학교, 고등보통학교, 여자고등보통학교, 실업학교, 사립학교 등의 교육 규칙을 만들고, 학교를 관리하려고
                                                    했습니다. 이를 통해 일본은 조선 식민지의 교육체제를 통제하고, 식민 통치에 유리한 방향으로 교육 제도를 만들고자
                                                    하였습니다.
                                                </p>
                                                <p>
                                                    <strong>· 제2차 조선 교육령</strong>
                                                    1919년 3.1운동 이후, 조선총독부는 1922년 제2차 조선교육령을 발표하며, 일본의 교육제도와 유사하게 식민지 교육
                                                    체제를 만들고자 하였습니다. 『일람』에서는 학교급명은 동일하게 기록되어 있으나, 1922년까지 조선인 학교와 일본인 학교의
                                                    범주와 기록이 명확히 구분되어 있는 모습을 확인할 수 있습니다. 예를 들어, 학교의 이름, 학제, 수학 연한 등에서 차이가
                                                    있었으며, 이런 차별적인 모습은 『일람』에 그대로 기록되어 있습니다.
                                                </p>
                                                <p>
                                                    <strong>· 제3차, 제4차 조선 교육령</strong>
                                                    조선교육령 시기에 조선인의 초등교육은 보통학교에서 이루어졌습니다. 보통학교의 교육연한, 교과목의 구조도 일본인 소학교와
                                                    여러 가지 면에서 차이가 있었습니다. 그러나 1938년 이후 제3차 교육령에 따라 조선인의 보통학교도 소학교 로 바뀝니다.
                                                    뒤이어 1941년 제4차 교육령에 따라 소학교가 국민학교로 학교급 명칭이 전환되었습니다. 이러한 개편은 조선인의 교육
                                                    기회를 형식적으로 확대한 것이었습니다. 하지만 곳곳에서 여전히 교육적 차별 요소는 존재했습니다. 『일람』에서는 이러한
                                                    조선총독부의 교육정책을 그대로 확인할 수 있습니다. 1938년도판 『일람』부터는 조선인 소학교와 국민학교가 일본인 학교와
                                                    함께 기록된 모습을 확인할 수 있습니다. 다만 조선인 소학교와 일본인 학교가 함께 기록 되었다고 하더라도, 그 기록 순서는
                                                    항상 일본인 학교가 먼저 나오고 있습니다. 이는 일본이 조선인을 일본식 교육체제로 통합하려 했지만, 조선인은 일본인보다
                                                    차별받고 있던 상황을 보여주는 예시라고 할 수 있습니다. 또한, 1923년부터는 서당이, 1942년부터는 정식 인가를 받지
                                                    못한 초등학교 수준의 학교들이 부록에 실린 모습도 확인할 수 있습니다.
                                                </p>
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                                <dl className="description">
                                    <dt>
                                        <Link to="#" className={activeDescription.includes(1) ? "des-tit on" : "des-tit"} onClick={() => toggleDescription(1)}>
                                            <p>일제강점기 조선총독부가 관심을 가졌던 실업학교도 변화합니다.</p>
                                            <i className="i-toggle"></i>
                                        </Link>
                                    </dt>
                                    <dd style={{
                                        height: activeDescription.includes(1) ? "auto" : "0",
                                        overflow: "hidden",
                                        transition: "height 0.3s ease",
                                    }}>
                                        <div className="des-view">
                                            <div className="text-wrap">
                                                <p>
                                                    『일람』을 보면 조선총독부가 어떤 실업학교를 중요하게 여겼는지 알 수 있습니다. 1923년부터 1942년까지의 기록을
                                                    살펴보면, 농업학교는 별도의 표에 기록되어 있고, 상업, 공업, 수산같은 다른 실업학교들은 실업학교라는 하나의 표로 묶여
                                                    있습니다. 이러한 구분은 일제의 식민지 정책과 깊은 연관이 있습니다. 일본은 조선을 식량 공급지로 삼기 위해 농업 생산력을
                                                    강화할 필요가 있었고, 이에 따라 조선총독부는 농업교육을 특히 중시했습니다. 하지만 태평양 전쟁이 발발하면서 농업 외의
                                                    다양한 실업학교와 보습학교도 따로 기록되기 시작했습니다. 많은 실업학교가 농업학교, 공업학교, 여자상업학교로 전환되었고,
                                                    이는 전쟁을 위한 식량 증산과 군수 산업에 필요한 인력을 확보하려는 일본의 의도가 반영된 결과입니다.
                                                </p>
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                                <dl className="description">
                                    <dt>
                                        <Link to="#" className={activeDescription.includes(2) ? "des-tit on" : "des-tit"} onClick={() => toggleDescription(2)}>
                                            <p>조선제학교일람을 통해 일제강점기 식민지 교육의 변화를 파악해 봅니다.</p>
                                            <i className="i-toggle"></i>
                                        </Link>
                                    </dt>
                                    <dd style={{
                                        height: activeDescription.includes(2) ? "auto" : "0",
                                        overflow: "hidden",
                                        transition: "height 0.3s ease",
                                    }}>
                                        <div className="des-view">
                                            <div className="text-wrap">
                                                <p>
                                                    연구센터 조사 결과, 『일람』은 1920년을 제외한 1917년부터 1943년까지 총 26권이 국내외 기관에 보관 중입니다.
                                                    이를 바탕으로 센터는 43,345건의 교육 통계를 입력했으며, 연도별 표로도 제공하고 있습니다. 표는 7~20개의 항목으로
                                                    나뉘며, 학교 수, 학급 수, 교원 수, 학생 수, 학교 운영 비용 등의 정보가 포함 되어 있습니다. 개별 학교 정보를
                                                    보면 학교명, 위치, 설립 연도도 자세히 기록되어 있습니다.
                                                </p>
                                                <p>
                                                    『일람』에서 확인할 수 있는 특이사항은 다음과 같습니다. 첫째, 1921년, 1923년, 1924년, 1925년 자료에서는
                                                    소학교와 보통학교에 대한 구체적인 정보보다 전체 통계가 중심이었습니다. 둘째, 1936년부터 1943년까지는 보통학교,
                                                    소학교, 초등학교 현황이 군 단위로 간략하게 기록되었습니다. 마지막으로, 원본 자료에는 학교명, 지역, 통계 숫자 등에서
                                                    일부 오류가 있지만, 입력할 당시 발견된 오류를 그대로 남겨 두고 있습니다.
                                                </p>
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default SchoolSearch;